import { pdfjs } from 'react-pdf'

/**
 * Points react-pdf at a locally bundled PDF.js worker.
 *
 * The worker used to be loaded from a protocol-relative unpkg URL:
 *
 *     `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`
 *
 * On an http origin that resolves to http://unpkg.com, which serves no
 * Access-Control-Allow-Origin header, so the browser blocked the worker and
 * every preview died with "Setting up fake worker failed". It also made the
 * viewer depend on a third-party CDN being up and on that CDN holding the exact
 * pdfjs version installed here.
 *
 * Resolving through the installed package instead means the worker is emitted
 * by the bundler, always matches `pdfjs-dist`, and needs no network at all.
 *
 * Imported for side effects, and shared so the several preview surfaces cannot
 * drift apart in how they configure it.
 */
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
	'pdfjs-dist/build/pdf.worker.min.mjs',
	import.meta.url,
).toString()

export default pdfjs.GlobalWorkerOptions.workerSrc
